import {
  Component,
  Input,
  HostBinding,
  Output,
  EventEmitter,
  Host,
  OnInit,
  OnDestroy
} from '@angular/core';
import { Accordion } from './accordion.component';
import { takeWhile } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'suka-accordion-item',
  template: `
    <button
      [attr.aria-expanded]="expanded"
      [attr.aria-controls]="id"
      (click)="toggle()"
      class="accordion__heading">
      <suka-icon icon="chevron-down" class="accordion__arrow"></suka-icon>
      <p
        class="accordion__title"
        [ngClass]="{
          'skeleton__text': skeleton
        }">
        {{!skeleton ? title : null}}
      </p>
    </button>
    <div [id]="id" class="accordion__content">
      <ng-content *ngIf="!skeleton; else skeletonTemplate"></ng-content>
      <ng-template #skeletonTemplate>
        <p class="skeleton__text" style="width: 90%"></p>
        <p class="skeleton__text" style="width: 80%"></p>
        <p class="skeleton__text" style="width: 95%"></p>
      </ng-template>
    </div>
  `,
})
export class AccordionItem implements OnInit, OnDestroy {
  static accordionItemCount = 0;
  @Input() title = `Title ${AccordionItem.accordionItemCount}`;
  @Input() id = `accordion-item-${AccordionItem.accordionItemCount}`;
  @Input() skeleton = false;
  @Output() opened = new EventEmitter();
  @Output() closed = new EventEmitter();

  @HostBinding('class.accordion__item') itemClass = true;
  @HostBinding('class.accordion__item--active') @Input() expanded = false;
  @HostBinding('style.display') itemType = 'list-item';
  @HostBinding('attr.role') role = 'heading';
  @HostBinding('attr.aria-level') @Input() ariaLevel = 3;

  private alive = true;
  private skeletonSubscription: Subscription;
  private openSubscription: Subscription;

  constructor(@Host() private accordion: Accordion) {
    AccordionItem.accordionItemCount++;
  }

  public toggle() {
    if (!this.skeleton) {
      if (!this.expanded) {
        if (!this.accordion.multi) {
          this.accordion.openCloseItems.next(true);
        }

        this.open();
      } else {
        this.close();
      }
    }
  }

  protected open() {
    if (!this.expanded) {
      this.opened.emit({ id: this.id });
    }

    this.expanded = true;
  }

  protected close() {
    if (this.expanded) {
      this.closed.emit({ id: this.id });
    }

    this.expanded = false;
  }

  ngOnInit() {
    this.openSubscription = this.accordion.openCloseItems
      .pipe(takeWhile(() => this.alive))
      .subscribe(collapsed => {
        if (!this.skeleton) {
          collapsed ? this.close() : this.open();
        }
      });

    this.skeletonSubscription = this.accordion.skeletons
      .pipe(takeWhile(() => this.alive))
      .subscribe(skeletonValue => this.skeleton = skeletonValue);

    this.skeleton = this.accordion.skeleton;
  }

  ngOnDestroy() {
    this.alive = false;
    this.openSubscription.unsubscribe();
    this.skeletonSubscription.unsubscribe();
  }
}
